// extracted by mini-css-extract-plugin
export var cartContainer = "_ia-4";
export var gray = "_ia-1";
export var itemContainer = "_ia-2";
export var itemDetails = "_ia-3";
export var strong = "_ia-0";